type Step = { n: string; title: string; body: string };

const steps: Step[] = [
  {
    n: '01',
    title: 'Paste your upstream credentials, once.',
    body: 'Drop in your OpenAI, Anthropic, Bedrock, or any other provider key. Mark each one as API key (per-token billing) or Subscription (flat fee, allocated pro-rata).',
  },
  {
    n: '02',
    title: 'Mint a labelled token per client.',
    body: 'One inbound token per engagement. Point Claude Code, Cursor, Cline, or any BYO-key tool at our base URL with that token — nothing else changes.',
  },
  {
    n: '03',
    title: 'We forward and tag every request.',
    body: "Traffic is proxied to the real upstream with your real credential. Every request is tagged with the client it belongs to and priced at the provider's rate. Zero markup.",
  },
  {
    n: '04',
    title: 'Hand the receipt to your accountant.',
    body: 'Per-client requests, tokens, and dollar cost in real time. 30-day sparkline. CSV export drops straight into Bonsai, Harvest, Xero, or FreshBooks.',
  },
];

export default function HowItWorks() {
  return (
    <section id="how" className="py-24 border-t-2 border-border">
      <div className="container-ledger">
        <div className="max-w-2xl mb-16">
          <div className="text-[11px] font-mono uppercase tracking-[0.18em] text-spray-magenta mb-4 font-bold">
            // How it works
          </div>
          <h2 className="font-display text-4xl md:text-5xl uppercase leading-[0.95]">
            A billing-attribution proxy.{' '}
            <span className="text-spray-yellow">Nothing more.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {steps.map((step) => (
            <div key={step.n} className="block-brutal p-7">
              <div className="font-display text-spray-yellow text-3xl mb-3">{step.n}</div>
              <h3 className="text-lg font-bold uppercase tracking-tight mb-2">{step.title}</h3>
              <p className="text-muted-foreground leading-relaxed text-sm">{step.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function SectionLabel({ children }: { children: React.ReactNode }) {
  return (
    <div className="text-[11px] font-mono uppercase tracking-[0.18em] text-spray-magenta mb-4 font-bold">
      // {children}
    </div>
  );
}
